export default __webpack_public_path__ + "img/Montserrat-ExtraBold_3e1f7a5.eot";